import { useEffect } from "react";
import { pendoTrackEventWithProperties } from "utils/pendo/pendoHelpers";
import type { AdSpacesEvents } from "./adSpacesEvents";

export type AdSpacesProps = Record<
  string,
  string | number | boolean | null | undefined
>;

/**
 * Sends one event. Called after a save has succeeded, so a throw here would
 * turn that success into an error toast and the operator might retry.
 */
export function trackAdSpaces(
  event: AdSpacesEvents,
  props: AdSpacesProps = {},
) {
  try {
    pendoTrackEventWithProperties(event, props);
  } catch (error) {
    console.error(`Ad Spaces tracking failed for ${event}`, error);
  }
}

/**
 * Fires a view event on mount and again whenever a prop value changes (e.g. the
 * active tab). Props are compared by value, so an inline object won't re-fire.
 * `enabled` holds the event until the page knows what it's showing.
 */
export function useTrackAdSpacesView(
  event: AdSpacesEvents,
  props: AdSpacesProps = {},
  enabled = true,
) {
  const key = JSON.stringify(props);
  useEffect(() => {
    if (enabled) trackAdSpaces(event, JSON.parse(key) as AdSpacesProps);
  }, [event, key, enabled]);
}
